export const SAC_TYPE = {
  PostComment: {
    name: 'Comentários',
    value: 'PostComment',
  },
  MentionComment: {
    name: 'Comentários em menções',
    value: 'MentionComment',
  },
  ReviewComment: {
    name: 'Comentários em avaliações',
    value: 'ReviewComment',
  },
  VisitorComment: {
    name: 'Comentário em publicação de visitante',
    value: 'VisitorComment',
  },
  Mention: {
    name: 'Menções',
    value: 'Mention',
  },
  Review: {
    name: 'Avaliações',
    value: 'Review',
  },
  Post: {
    name: 'Publicações proprietárias',
    value: 'Post',
  },
  VisitorPost: {
    name: 'Publicações de visitante',
    value: 'VisitorPost',
  },
  Inbox: {
    name: 'Inbox',
    value: 'Inbox',
  },
  Story: {
    name: 'Story',
    value: 'Story',
  },
  Reels: {
    name: 'Reels',
    value: 'Reels',
  },
};

const SAC_TYPE_MAP = {
  PostComment: SAC_TYPE.PostComment.name,
  MentionComment: SAC_TYPE.MentionComment.name,
  ReviewComment: SAC_TYPE.ReviewComment.name,
  VisitorComment: SAC_TYPE.VisitorComment.name,
  Mention: SAC_TYPE.Mention.name,
  Review: SAC_TYPE.Review.name,
  Post: SAC_TYPE.Post.name,
  VisitorPost: SAC_TYPE.VisitorPost.name,
  Inbox: SAC_TYPE.Inbox.name,
  Story: SAC_TYPE.Story.name,
  Reels: SAC_TYPE.Reels.name,
};

export default {
  data() {
    return {
      sacTypeList: SAC_TYPE_MAP,
      typesObj: SAC_TYPE,
      channelSacTypes: {
        facebook: [
          SAC_TYPE.Post.value,
          SAC_TYPE.PostComment.value,
          SAC_TYPE.Mention.value,
          SAC_TYPE.MentionComment.value,
          SAC_TYPE.Inbox.value,
          SAC_TYPE.VisitorPost.value,
          SAC_TYPE.VisitorComment.value,
          SAC_TYPE.Review.value,
          SAC_TYPE.ReviewComment.value,
        ],
        instagram: [
          SAC_TYPE.Post.value,
          SAC_TYPE.Mention.value,
          SAC_TYPE.PostComment.value,
          SAC_TYPE.MentionComment.value,
          SAC_TYPE.Story.value,
          SAC_TYPE.Inbox.value,
          SAC_TYPE.Reels.value,
        ],
        twitter: [
          SAC_TYPE.Post.value,
          SAC_TYPE.Inbox.value,
          SAC_TYPE.Mention.value,
          SAC_TYPE.PostComment.value,
          SAC_TYPE.MentionComment.value,
        ],
        youtube: [
          SAC_TYPE.Post.value,
          SAC_TYPE.PostComment.value,
        ],
        linkedin: [
          SAC_TYPE.Post.value,
          SAC_TYPE.PostComment.value,
        ],
        TikTok: [
          SAC_TYPE.PostComment.value,
        ],
      },
    };
  },
  methods: {
    getTypesByChannels(channels = []) {
      const allTypes = channels.reduce((types, channel) => {
        const channelTypes = this.channelSacTypes[channel] || [];
        return [...types, ...channelTypes];
      }, []);
      return Array.from(new Set(allTypes));
    },
  },
};
